import script from "./DepartmentModify.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentModify.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentModify.vue?vue&type=style&index=0&id=4c62d180&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c62d180"]])

export default __exports__